export const LOADER_COMPETENCIES_DESC         =        'LOADER_COMPETENCIES_DESC';
export const SAVE_LOADER_COMPETENCIES_DESC    =        'SAVE_LOADER_COMPETENCIES_DESC';
export const GET_COMPETENCIES_DESC            =        'GET_COMPETENCIES_DESC';
export const FORM_COMPETENCIES_DESC_FAIL      =        'FORM_COMPETENCIES_DESC_FAIL';
export const COMPETENCIES_DESC_FAIL           =        'COMPETENCIES_DESC_FAIL';
export const LOADER_COMPETENCIES_DESC_BY_ID   =        'LOADER_COMPETENCIES_DESC_BY_ID';
export const GET_COMPETENCIES_DESC_BY_ID      =        'GET_COMPETENCIES_DESC_BY_ID';